import React from "react";
import Checkbox from "../../common/form/Checkbox";

export default function ExceededLimitsInput({ value, onChange }) {
  return (
    <label>
      <Checkbox checked={value} onChange={e => onChange(e.target.checked)} />
    </label>
  );
}
